var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from "react";
import styled from "styled-components";
import Overlay, { isOverlay } from "./Overlay";
import Column from "./Column";
const Modal = props => {
    const { onOverlayClick } = props, rest = __rest(props, ["onOverlayClick"]);
    const handleOverlayClick = useCallback((event) => {
        if (onOverlayClick && isOverlay(event.target)) {
            onOverlayClick(event);
        }
    }, [onOverlayClick]);
    return (React.createElement(StyledOverlay, { onClick: handleOverlayClick },
        React.createElement(Window, Object.assign({}, rest, { role: "dialog", "aria-modal": "true" }))));
};
export default styled(Modal) ``;
const StyledOverlay = styled(Overlay) `
  padding-top: 5rem;

  /* Add space beneath the window (margin and padding don't seem to always work here) */
  &::after {
    content: "";
    height: 5rem;
    display: block;
    flex-shrink: 0;
  }
`;
const Window = styled(Column) `
  align-self: center;
  background-color: white;
  max-width: 90%;
  width: 500px;
  padding: 3rem 3rem 3rem 3rem;
  box-sizing: border-box;

  @media screen and (max-width: 600px) {
    padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  }
`;
